import React, { useState } from 'react';

const ProductScheme = () => {
  // State for form data
  const [selectedDivision, setSelectedDivision] = useState('');
  const [normalScheme, setNormalScheme] = useState({
    quantity: 0,
    freeQuantity: 0,
    freePercent: 0.00,
    startDate: '2025-08-01',
    endDate: '2025-08-31',
    remarks: ''
  });
  const [extraScheme, setExtraScheme] = useState({
    minQuantity: 0,
    bonusPercent: 0,
    startDate: '2025-08-01',
    endDate: '2025-08-31',
    remarks: ''
  });
  const [hqScheme, setHqScheme] = useState({
    minQuantity: 0,
    bonusPercent: 0,
    remarks: ''
  });

  // Divisions data
  const divisions = [
    { id: 4, name: 'COSMACIA' },
    { id: 7, name: 'ESENCIA HC' },
    { id: 8, name: 'ESENCIA WL' },
    { id: 2, name: 'HEALTHCARE' },
    { id: 6, name: 'KPKB' },
    { id: 1, name: 'LHL' },
    { id: 5, name: 'OTC' },
    { id: 3, name: 'WELLNESS' }
  ];

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would typically send the data to your backend
    console.log({
      selectedDivision,
      normalScheme,
      extraScheme,
      hqScheme
    });
    alert('Scheme submitted successfully!');
  };

  // Handle input changes
  const handleNormalSchemeChange = (e) => {
    const { name, value } = e.target;
    setNormalScheme(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleExtraSchemeChange = (e) => {
    const { name, value } = e.target;
    setExtraScheme(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleHqSchemeChange = (e) => {
    const { name, value } = e.target;
    setHqScheme(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="container mx-auto p-4">
      <fieldset className="border p-4 rounded-lg">
        <legend className="text-lg font-bold text-blue-600 px-2">
          Product Normal and Extra Scheme
        </legend>
        
        <div className="my-4">
          <hr className="border-gray-300" />
        </div>

        {/* Division Selection */}
        <div className="mb-6 border rounded-lg p-4">
          <legend className="text-blue-500 font-semibold px-2">Division</legend>
          <div className="mt-2">
            <label className="font-bold block mb-2">Division</label>
            <div className="border border-gray-400 rounded p-2 h-40 overflow-y-auto">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
                {divisions.map(division => (
                  <div key={division.id} className="flex items-center">
                    <input
                      type="radio"
                      id={`division-${division.id}`}
                      name="division"
                      value={division.id}
                      checked={selectedDivision === division.id.toString()}
                      onChange={(e) => setSelectedDivision(e.target.value)}
                      className="mr-2"
                    />
                    <label htmlFor={`division-${division.id}`}>{division.name}</label>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Product Selection */}
        <div className="mb-6 border rounded-lg p-4">
          <legend className="text-blue-500 font-semibold px-2">Product</legend>
          <div className="mt-2">
            <label className="font-bold block mb-2">Products</label>
            <div className="border border-gray-400 rounded p-2 h-64 overflow-y-auto">
              <p className="text-gray-500 text-center py-20">No products selected</p>
            </div>
          </div>
        </div>

        {/* Normal Scheme */}
        <div className="mb-6 border rounded-lg p-4">
          <legend className="text-blue-500 font-semibold px-2">Normal Scheme</legend>
          <div className="mt-2">
            <table className="w-full">
              <tbody>
                <tr>
                  <td className="py-2">
                    <div className="grid grid-cols-1 md:grid-cols-6 gap-4 items-center">
                      <div className="font-bold">Quantity</div>
                      <div>
                        <input
                          type="number"
                          name="quantity"
                          value={normalScheme.quantity}
                          onChange={handleNormalSchemeChange}
                          className="w-full p-1 border rounded text-right"
                          min="0"
                        />
                      </div>
                      <div className="font-bold">Free Quantity</div>
                      <div>
                        <input
                          type="number"
                          name="freeQuantity"
                          value={normalScheme.freeQuantity}
                          onChange={handleNormalSchemeChange}
                          className="w-full p-1 border rounded text-right"
                          min="0"
                        />
                      </div>
                      <div className="text-blue-500 font-bold">Free Percent</div>
                      <div>
                        <input
                          type="number"
                          name="freePercent"
                          value={normalScheme.freePercent}
                          onChange={handleNormalSchemeChange}
                          className="w-full p-1 border rounded text-right bg-white border-0 font-bold"
                          min="0"
                          step="0.01"
                        />%
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="py-2">
                    <div className="grid grid-cols-1 md:grid-cols-6 gap-4 items-center">
                      <div className="font-bold">Start Date</div>
                      <div>
                        <input
                          type="date"
                          name="startDate"
                          value={normalScheme.startDate}
                          onChange={handleNormalSchemeChange}
                          className="w-full p-1 border rounded text-center"
                        />
                      </div>
                      <div className="font-bold">End Date</div>
                      <div>
                        <input
                          type="date"
                          name="endDate"
                          value={normalScheme.endDate}
                          onChange={handleNormalSchemeChange}
                          className="w-full p-1 border rounded text-center"
                        />
                      </div>
                      <div></div>
                      <div></div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            
            {/* Remarks */}
            <div className="mt-4 border rounded-lg p-2">
              <legend className="px-2">Remarks</legend>
              <textarea
                name="remarks"
                value={normalScheme.remarks}
                onChange={handleNormalSchemeChange}
                className="w-full p-2 border rounded h-20"
                placeholder="Enter remarks here..."
              />
            </div>
          </div>
        </div>

        {/* Extra Scheme */}
        <div className="mb-6 border rounded-lg p-4">
          <legend className="text-blue-500 font-semibold px-2">Extra Scheme</legend>
          <div className="mt-2">
            <table className="w-full">
              <tbody>
                <tr>
                  <td className="py-2">
                    <div className="grid grid-cols-1 md:grid-cols-6 gap-4 items-center">
                      <div className="font-bold">Minimum Order Quantity (MOQ)</div>
                      <div>
                        <input
                          type="number"
                          name="minQuantity"
                          value={extraScheme.minQuantity}
                          onChange={handleExtraSchemeChange}
                          className="w-full p-1 border rounded text-right"
                          min="0"
                        />
                      </div>
                      <div className="font-bold">Extra Bonus Quantity (EBQ) %</div>
                      <div>
                        <input
                          type="number"
                          name="bonusPercent"
                          value={extraScheme.bonusPercent}
                          onChange={handleExtraSchemeChange}
                          className="w-full p-1 border rounded text-right"
                          min="0"
                        />%
                      </div>
                      <div></div>
                      <div></div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td className="py-2">
                    <div className="grid grid-cols-1 md:grid-cols-6 gap-4 items-center">
                      <div className="font-bold">Start Date</div>
                      <div>
                        <input
                          type="date"
                          name="startDate"
                          value={extraScheme.startDate}
                          onChange={handleExtraSchemeChange}
                          className="w-full p-1 border rounded text-center"
                        />
                      </div>
                      <div className="font-bold">End Date</div>
                      <div>
                        <input
                          type="date"
                          name="endDate"
                          value={extraScheme.endDate}
                          onChange={handleExtraSchemeChange}
                          className="w-full p-1 border rounded text-center"
                        />
                      </div>
                      <div></div>
                      <div></div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            
            {/* Remarks */}
            <div className="mt-4 border rounded-lg p-2">
              <legend className="px-2">Remarks</legend>
              <textarea
                name="remarks"
                value={extraScheme.remarks}
                onChange={handleExtraSchemeChange}
                className="w-full p-2 border rounded h-20"
                placeholder="Enter remarks here..."
              />
            </div>
          </div>
        </div>

        {/* HQ Scheme */}
        <div className="mb-6 border rounded-lg p-4">
          <legend className="text-blue-500 font-semibold px-2">HQ Scheme</legend>
          <div className="mt-2">
            <table className="w-full">
              <tbody>
                <tr>
                  <td className="py-2">
                    <div className="grid grid-cols-1 md:grid-cols-6 gap-4 items-center">
                      <div className="font-bold">HQ Minimum Order Quantity (MOQ)</div>
                      <div>
                        <input
                          type="number"
                          name="minQuantity"
                          value={hqScheme.minQuantity}
                          onChange={handleHqSchemeChange}
                          className="w-full p-1 border rounded text-right"
                          min="0"
                        />
                      </div>
                      <div className="font-bold">Extra Bonus Quantity (EBQ) %</div>
                      <div>
                        <input
                          type="number"
                          name="bonusPercent"
                          value={hqScheme.bonusPercent}
                          onChange={handleHqSchemeChange}
                          className="w-full p-1 border rounded text-right"
                          min="0"
                        />%
                      </div>
                      <div></div>
                      <div></div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            
            {/* Remarks */}
            <div className="mt-4 border rounded-lg p-2">
              <legend className="px-2">Remarks</legend>
              <textarea
                name="remarks"
                value={hqScheme.remarks}
                onChange={handleHqSchemeChange}
                className="w-full p-2 border rounded h-20"
                placeholder="Enter remarks here..."
              />
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="flex justify-center space-x-4 mt-6">
          <button
            type="submit"
            onClick={handleSubmit}
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          >
            Submit
          </button>
          <button
            type="button"
            className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded"
          >
            Return
          </button>
        </div>
      </fieldset>
    </div>
  );
};

export default ProductScheme;